module.exports = __webpack_public_path__ + "d4ecdc2633da4bf30fdcf770a3c7737a.pdf";